// extracted by mini-css-extract-plugin
export var RichText = "L_b1";
export var aniBgLoading = "L_f";
export var aniSpin = "L_d";
export var headingStyles = "L_b3";
export var imageStyles = "L_b4";
export var listStyles = "L_b2";
export var tableStyles = "L_b5";